import { useCallback, useEffect, useState } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';

import { useHttpUtils } from '../../Utilities/useHttpUtils'
import useAlert from '../../Alerts/useAlert';
import AdminTile from './AdminTile';

const SiteAlerts = () => {
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const [siteAlert, setSiteAlert] = useState("");
    const [formAlertVariant, setFormAlertVariant] = useState("primary");
    const [formAlertText, setFormAlertText] = useState("");
    const [error, setError] = useState();
    const [variant, setVariant] = useState();

    const getAlert = useCallback(() => {
        fetchDataAuthenticated("api/v1/users/siteAlert", "GET")
            .then(response => {
                if (!response.ok) {
                    return response.json().then(error => Promise.reject(error));
                }
                return response.json();
            })
            .then(data => {
                setVariant("");
                setSiteAlert(data.text);
                setFormAlertText(data.text);
                setFormAlertVariant(data.variant);
                setError(null);
            }).catch(error => {
                setVariant("danger");
                setAlert("danger", error.title, error.detail);
                setSiteAlert();
                setFormAlertText("");
                setError(error.detail);
            });
    }, [fetchDataAuthenticated, setAlert]);

    useEffect(() => {
        getAlert();
    }, [getAlert]);

    const updateAlert = async () => {
        var body = {
            variant: formAlertVariant,
            text: formAlertText
        };

        await fetchDataAuthenticated("api/v1/admin/siteAlert", "PUT", JSON.stringify(body));

        window.location.reload();
    }

    return (
        <AdminTile
            title="Set Site Alert"
            description="Check and set the site alert banner"
            variant={variant}>
            <>
                <Row>
                    <Col>
                        {error ? error : siteAlert || "No Alert Set"}
                    </Col>
                </Row>
                <Row className="mt-2 mb-2">
                    <Form>
                        <Form.Group>
                            <Form.Label><strong>Set Alert Variant</strong></Form.Label>
                            <Form.Select
                                value={formAlertVariant}
                                onChange={(e) => setFormAlertVariant(e.target.value)}>
                                {["info", "warning", "danger", "success", "primary", "secondary"].map(variant => (
                                    <option key={variant}
                                        value={variant}>
                                        {variant}
                                    </option>))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mt-2">
                        </Form.Group>
                        <Form.Group className="mt-2">
                            <Form.Label><strong>Set Alert</strong></Form.Label>
                            <Form.Control variant="text" value={formAlertText} onChange={(e) => setFormAlertText(e.target.value)} placeholder="Enter new alert" />
                        </Form.Group>
                    </Form>
                </Row>
                <Button type="submit" className="ms-auto mt-auto" onClick={updateAlert}>Set</Button>
            </>
        </AdminTile>
    );
}

export default SiteAlerts;